import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useBranding } from '../../context/BrandingContext';
import { Button } from '../ui/button';
import { Sparkles, Settings } from 'lucide-react';
import NotificationBell from '../NotificationBell';
import UserMenu from './UserMenu';
import GlobalSearch from './GlobalSearch';

/** Barra fissa in alto: logo a sinistra, account e avvisi a destra (desktop). */
export const TopBar = () => {
  const { API } = useAuth();
  const { branding } = useBranding();
  const navigate = useNavigate();

  return (
    <header
      className="sticky top-0 z-50 h-16 shrink-0 border-b border-border bg-card/90 backdrop-blur-md"
      data-testid="top-bar"
    >
      <div className="h-full px-4 lg:px-6 flex items-center justify-between gap-4">
        <Link to="/dashboard" className="flex items-center gap-2 min-w-0" data-testid="top-bar-logo">
          {branding.logo_url ? (
            <img src={`${API}${branding.logo_url}`} alt={branding.brand_name || 'Logo'}
              className="h-8 w-auto max-w-[140px] object-contain" />
          ) : (
            <span className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
              <Sparkles className="w-4 h-4 text-primary" />
            </span>
          )}
          <span className="font-outfit font-semibold text-lg truncate" data-testid="top-bar-brand">
            {branding.brand_name || 'Salon Suite'}
          </span>
        </Link>

        <div className="flex items-center gap-1">
          <div className="lg:hidden">
            <GlobalSearch variant="icon" />
          </div>
          <div className="hidden lg:block mr-2">
            <GlobalSearch />
          </div>
          <div className="hidden lg:flex items-center gap-1" data-testid="top-bar-actions">
            <div className="w-10 flex justify-center">
              <NotificationBell collapsed topbar />
            </div>
            <Button variant="ghost" size="icon" onClick={() => navigate('/settings')}
              data-testid="top-bar-settings">
              <Settings className="w-5 h-5" />
            </Button>
            <div className="w-px h-6 bg-border mx-1" />
            <UserMenu showName />
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopBar;
